var voted_users_rtlignore_default = {
  "container": "ZQNdI",
  "webview": "Wc83r",
  "avatar_list": "VELcv",
  "avatar": "dmr57",
  "user_avatar": "CHH7W",
  "modal": "SD3xb",
  "voted_users_modal": "kD-Cz",
  "overlay": "D6KXR",
  "user_card": "qpAW-",
  "user_name": "_8-jah",
  "voted_users_modal_header": "ma-IJ",
  "cta": "_6G-1N",
  "close_icon": "mFxQz",
  "title": "tu6Er",
  "member_list_container": "LqXj5",
  "member_list": "vGBD-",
  "loader": "-O9KH",
  "anonymous_counter": "_9Lp5E",
  "spinner": "AF0Ie",
  "spin": "GogIS"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
